import { useContext, useMemo, RefCallback, ReactNode } from 'react'
import cn from 'classnames/bind'
import { reduce, values } from 'ramda'
import { useTranslation } from 'react-i18next'

import { useCurrencySign } from 'app/common/components-next/currency'
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue'
import { PageTemplateContent, Header2 } from 'app/common/templates-next/page-template'

import { SubsidiesContext, type Subsidy } from '../CafeteriaSubsidiesData'
import styles from './SubsidiesHeaderBar.module.scss';

const cx = cn.bind(styles)

type Props = {
  header: string
  className?: string
  reference: RefCallback<any>
  children: ReactNode
}

const SubsidiesHeaderBar = ({ header, className, reference, children }: Props) => {
  const { t } = useTranslation('cafeteria')
  const currency = useCurrencySign()
  const {
    content: { subsidies },
    loading: { subsidies: loading },
  } = useContext(SubsidiesContext)

  const total = useMemo(() => {
    const sum = reduce(
      (acc, { spent }: Subsidy) => {
        return acc + (spent || 0)
      },
      0,
      values(subsidies),
    )

    return `${t('purchases_total', 'Итого')}: ${toFixedValueCurrency(sum, false, currency)}`
  }, [subsidies, currency, t])

  return (
    <PageTemplateContent className={className} reference={reference} flex skipPadding>
      <Header2 className={styles.header} skipMargin>
        {header}
      </Header2>
      <Header2 className={cx(styles.total, { loading })} wide={false} skipMargin>
        {total}
      </Header2>
      {children}
    </PageTemplateContent>
  )
}

export default SubsidiesHeaderBar
